import { type StateCreator, create } from "zustand";
import { devtools /*persist*/ } from "zustand/middleware";
import {
	MergedGpEventResponse,
	PlayerBadgesModalData,
	PlayerBadgesModalMode,
	PlayerRatingModalData,
	PlayerRatingVisibility,
} from "./types";

const initPlayerRatingModal: PlayerRatingModalData = {
	id: 0,
	show: false,
	name: null,
	rating: {
		visibility: PlayerRatingVisibility.Coach,
		ratedBy: null,
		ratedAt: null,
	},
};

const initPlayerBadgesModal: PlayerBadgesModalData = {
	id: 0,
	show: false,
	name: null,
	badgeIds: [],
	mode: PlayerBadgesModalMode.Save,
};

interface EditState {
	editEvent: MergedGpEventResponse | null;
	setEditEvent: (editEvent: MergedGpEventResponse | null) => void;
	selectedEvents: MergedGpEventResponse[];
	setSelectedEvents: (selectedEvents: MergedGpEventResponse[] | ((previous: MergedGpEventResponse[]) => MergedGpEventResponse[])) => void;
	showClipCreateModal: boolean;
	setShowClipCreateModal: (showClipCreateModal: boolean) => void;
	showReportErrorModal: boolean;
	setShowReportErrorModal: (showReportErrorModal: boolean) => void;
	playerRatingModal: PlayerRatingModalData;
	setPlayerRatingModal: (playerRatingModal: PlayerRatingModalData) => void;
	closePlayerRatingModal: () => void;
	playerBadgesModal: PlayerBadgesModalData;
	setPlayerBadgesModal: (playerBadgesModal: PlayerBadgesModalData) => void;
	closePlayerBadgesModal: () => void;
}
type Store = StateCreator<EditState>;

const store: Store = (set, get) => ({
	editEvent: null,
	selectedEvents: [],
	showClipCreateModal: false,
	showReportErrorModal: false,
	playerRatingModal: initPlayerRatingModal,
	playerBadgesModal: initPlayerBadgesModal,
	setEditEvent: (editEvent) => {
		set((state) => {
			return { ...state, editEvent };
		});
	},
	setSelectedEvents(selectedEvents) {
		let events: MergedGpEventResponse[] = [];
		if (typeof selectedEvents === "function") {
			events = selectedEvents(get().selectedEvents);
		} else {
			events = selectedEvents;
		}
		set((state) => {
			return { ...state, selectedEvents: events };
		});
	},
	setShowClipCreateModal(showClipCreateModal) {
		set((state) => {
			return { ...state, showClipCreateModal };
		});
	},
	setShowReportErrorModal(showReportErrorModal) {
		set((state) => {
			return { ...state, showReportErrorModal };
		});
	},
	setPlayerRatingModal(playerRatingModal) {
		set((state) => {
			return { ...state, playerRatingModal };
		});
	},
	closePlayerRatingModal() {
		set((state) => {
			return { ...state, playerRatingModal: initPlayerRatingModal };
		});
	},
	setPlayerBadgesModal(playerBadgesModal) {
		set((state) => {
			return { ...state, playerBadgesModal };
		});
	},
	closePlayerBadgesModal() {
		set((state) => {
			return { ...state, playerBadgesModal: initPlayerBadgesModal };
		});
	},
});

export const useStore = create<EditState>()(
	devtools(
		// persist(store, {
		// 	name: "admin-storage",
		// }),
		store,
		{
			//@ts-ignore
			enabled: import.meta.env.DEV,
			name: "game-edit-store",
		}
	)
);

export const useEditStore = () => useStore((state) => state);
